/* Case Planet — premium chip selectors (they drive the theme's hidden selects). */
(() => {
  'use strict';
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function bind(host) {
    if (host.dataset.cpChipsReady) return;
    host.dataset.cpChipsReady = '1';
    const select = document.getElementById(host.dataset.cpChipsFor);
    if (!select) return;

    const render = () => {
      const opts = Array.from(select.options).filter(o => o.value !== '');
      host.replaceChildren(...opts.map(o => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'cp-chip';
        b.setAttribute('role', 'radio');
        b.dataset.value = o.value;
        b.textContent = o.textContent.replace(/\s*\(sold out\)\s*$/i, '');
        const on = select.value === o.value;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', String(on));
        if (o.disabled) { b.disabled = true; b.title = 'Sold out'; }
        return b;
      }));
      if (opts.length === 0) {
        const hint = document.createElement('span');
        hint.className = 'cp-chips__hint';
        hint.textContent = 'Select your device first';
        host.appendChild(hint);
      }
    };

    host.addEventListener('click', e => {
      const b = e.target.closest('.cp-chip');
      if (!b || b.disabled) return;
      select.value = b.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      render();
    });

    select.addEventListener('change', render);
    new MutationObserver(render).observe(select, { childList: true, attributes: true, attributeFilter: ['disabled'] });
    // Selection can also change programmatically (syncing pickers, ?variant= links)
    setInterval(() => {
      const on = host.querySelector('.cp-chip.is-on');
      if ((on ? on.dataset.value : '') !== select.value) render();
    }, 700);
    render();
  }

  const init = (scope = document) => $$('[data-cp-chips-for]', scope).forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

/* Case Planet — remove the photo's connected light/neutral background cleanly.
   The product itself is preserved because only pixels connected to the image edges are removed. */
(() => {
  'use strict';

  function removeConnectedBackground(img) {
    if (!img || img.dataset.cpBgFixed === '1') return;

    const run = () => {
      if (img.dataset.cpBgFixed === '1') return;

      try {
        const w = img.naturalWidth;
        const h = img.naturalHeight;
        if (!w || !h) return;

        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;

        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        if (!ctx) return;

        ctx.drawImage(img, 0, 0);

        const image = ctx.getImageData(0, 0, w, h);
        const d = image.data;
        const total = w * h;
        const seen = new Uint8Array(total);
        const queue = new Int32Array(total);
        let head = 0;
        let tail = 0;

        // Background is the light, low-saturation area around the product.
        // A lower brightness threshold removes the remaining grey/white halo
        // while the edge-connected rule keeps enclosed white product areas.
        const isBackground = (p) => {
          const r = d[p];
          const g = d[p + 1];
          const b = d[p + 2];
          const max = Math.max(r, g, b);
          const min = Math.min(r, g, b);
          return min >= 118 && (max - min) <= 48 && ((r + g + b) / 3) >= 128;
        };

        const push = (x, y) => {
          if (x < 0 || y < 0 || x >= w || y >= h) return;
          const i = y * w + x;
          if (seen[i]) return;

          const p = i * 4;
          if (!isBackground(p)) return;

          seen[i] = 1;
          queue[tail++] = i;
        };

        // Start from every edge so only the outside background is removed.
        for (let x = 0; x < w; x++) {
          push(x, 0);
          push(x, h - 1);
        }
        for (let y = 0; y < h; y++) {
          push(0, y);
          push(w - 1, y);
        }

        while (head < tail) {
          const i = queue[head++];
          const p = i * 4;

          // Fully transparent background.
          d[p + 3] = 0;

          const x = i % w;
          const y = Math.floor(i / w);

          push(x + 1, y);
          push(x - 1, y);
          push(x, y + 1);
          push(x, y - 1);
        }

        ctx.putImageData(image, 0, 0);

        const cleaned = canvas.toDataURL('image/png');
        img.src = cleaned;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.dataset.cpBgFixed = '1';
      } catch (error) {
        // Leave the original image intact if canvas processing is blocked.
      }
    };

    if (img.complete && img.naturalWidth) run();
    else img.addEventListener('load', run, { once: true });
  }

  function init(scope = document) {
    scope
      .querySelectorAll('.cp-eng .cp-photo__base, .cp-eng .cp-photo__wheel img')
      .forEach(removeConnectedBackground);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
